import React from "react";
import Header from "../components/header/header";
import FAQ from "../components/extras/FAQ";
import Schedule from "../components/extras/schedule";
import '../App.css';
import '../style/info.css';
import HeaderImage from "../images/headers/orange_diagonals.svg";

const Info = () => {
    return (
        <>
            {/* <Header text="" text2="" tag="info" backgroundImage={HeaderImage}/> */}
            {/* <div className="this-year"> */}
                {/* <h1> 2 0 2 6 </h1> */}
                {/* <Schedule/> */}
                {/* <div className="contact-method" id="groupMe"> */}
                    {/* GroupMe QR Codes */}
                    {/* <div>
                        <h3>MDM Announcements</h3>
                        <img src={require("../images/QR-Announcements.png")} alt={"GroupMe Announcements"} loading="lazy"/>
                    </div>
                    <div>
                        <h3>MDM Student Chat</h3>
                        <img src={require("../images/QR-Students.png")} alt={"GroupMe Student Chat"} loading="lazy"/>
                    </div> */}
                {/* </div> */}
                {/*<br/>*/}
                {/* <div className="location-details">
                    <h2> Event Map </h2>
                    <img src={require("../images/eventMap.png")} alt={"Campus Temporary Map"} loading="lazy"/>
                </div> */}
            {/* </div> */}
            {/* <FAQ/> */}
            {/* <div id="footer-image"/>  */}




        {/* UT Year */}

            <div className="info-title">
                More Information
            </div>

            <div className="button-container">
                <a href="https://groupme.com/join_group/112202623/dy9f6w59"
            target="_blank"
            rel="noopener noreferrer"
            id="groupMe-button"
            >Join the GroupMe</a> 

                <a href="https://docs.google.com/document/d/1WJzIK639CKazkCp2vyzhG2ocbCH1FkiUIzoYjfne5xk/preview?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            id="faq-button"
            >Housing and Transportation FAQ</a> 

            </div>



        </>
    );
}

export default Info;